import {
  FETCH_SETTINGS,
  FETCH_SETTINGS_SUCCESS,
  FETCH_SETTINGS_FAILED,
  EDIT_SETTINGS,
  CLEAR_SETTINGS_ERROR,
} from "../store/types";

import store from "../store/store";
import { firebase } from "../config/configureFirebase";
import { onValue, set } from "firebase/database";

export const fetchSettings = () => (dispatch) => {
  const { settingsRef } = firebase;

  dispatch({
    type: FETCH_SETTINGS,
    payload: null,
  });

  if (!settingsRef) {
    console.error(
      "fetchSettings: settingsRef is MISSING! Firebase init issue?",
    );
    dispatch({
      type: FETCH_SETTINGS_FAILED,
      payload: "Firebase initialization error: settingsRef missing",
    });
    return;
  }

  onValue(
    settingsRef,
    (snapshot) => {
      if (snapshot.val()) {
        dispatch({
          type: FETCH_SETTINGS_SUCCESS,
          payload: snapshot.val(),
        });
      } else {
        dispatch({
          type: FETCH_SETTINGS_FAILED,
          payload: "Unable to fetch database and settings.",
        });
      }
    },
    (error) => {
      console.error("Settings Fetch Error:", error);
      dispatch({
        type: FETCH_SETTINGS_FAILED,
        payload: error.message,
      });
    },
  );
};

export const editSettings = (settings) => (dispatch) => {
  const { settingsRef } = firebase;
  const sanitized = Object.fromEntries(
    Object.entries(settings).filter(([, value]) => value !== undefined),
  );
  dispatch({
    type: EDIT_SETTINGS,
    payload: sanitized,
  });
  set(settingsRef, sanitized);
  alert(store.getState().languagedata.defaultLanguage.updated);
};

export const clearSettingsViewError = () => (dispatch) => {
  dispatch({
    type: CLEAR_SETTINGS_ERROR,
    payload: null,
  });
};
